import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8a8 8 0 0 1-8 8z",
  opacity: ".5",
  fill: "#CDEBFF"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M20 12h2A10 10 0 0 0 12 2v2a8 8 0 0 1 8 8z",
  fill: "#4397CB"
}, [
  /*#__PURE__*/_createElementVNode("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 12 12",
    to: "360 12 12",
    dur: "1s",
    repeatCount: "indefinite"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    "aria-hidden": "true",
    role: "img",
    width: _ctx.width,
    height: _ctx.height,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24"
  }, _hoisted_4, 8, _hoisted_1))
}